// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2pFT0","addWidgetButton":"Header_addWidgetButton__3K95c","dashboardTabs":"Header_dashboardTabs__1DXjm","active":"Header_active__ETL6_"};